<template>

  <modalo
    :title="templatemail.name"
    type="small"
    @hideModal="hideModal()"
    :modaloWatch="() => templatemail">

    <form id="templatemail-form" v-on:submit.prevent="saveTemplatemail(templatemail)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input v-autofocus type="text" class="form-control" v-model="templatemail.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>
      <div class="form-group">
        <label>{{ $t('Type') }}</label>
        <select class="form-control" v-model="templatemail.type">
          <option value="message">{{ $t('Message') }}</option>
          <option value="disqualify">{{ $t('Disqualification') }}</option>
        </select>
        <ValidateMessage :error="validateErrors.type" />
      </div>
      <div class="form-group">
        <label>{{ $t('Subject') }}</label>
        <input type="text" class="form-control" v-model="templatemail.subject">
        <ValidateMessage :error="validateErrors.subject" />
      </div>

      <div class="form-group">
        <textarea-editable
          v-model="templatemail.body"
          :variables="['[candidate_full_name]', '[candidate_first_name]', '[job_title]', '[company_name]', '[member_full_name]', '[member_first_name]']"
          editor-model="html"
          :enable-link="true"
          :enable-img="true">
          <!--'[job_link]' recursos funcionando mas desabilitado temporariamente para verificar se realmente vale a pena-->
          </textarea-editable>
        <ValidateMessage :error="validateErrors.body" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="templatemail-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="templatemail._id"
          type="button"
          class="btn btn-danger"
          @click="deleteTemplatemail(templatemail._id)">{{ $t('Delete') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'TemplatemailForm',
  components: {
  },
  props: [
    'initTemplatemail'
  ],
  data () {
    return {
      loading: false,
      templatemail: this.defaultValues(this.initTemplatemail),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveTemplatemail
    */
    saveTemplatemail (data) {
      if (data._id) this.updateTemplatemail(data)
      else this.createTemplatemail(data)
    },
    /*
    createTemplatemail
    */
    createTemplatemail (data) {
      this.loading = true

      this.$store
      .dispatch('createTemplatemail', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateTemplatemail
    */
    updateTemplatemail (data) {
      this.loading = true

      this.$store
      .dispatch('updateTemplatemail', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteTemplatemail (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteTemplatemail', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Templatemail/TemplatemailForm.vue